// extracted by mini-css-extract-plugin
module.exports = {"icon":"Index_icon__30N-u","text":"Index_text__2d6vu"};